// ======================================================================
// File Name       : TopNavigatorConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import * as Path from './PathConstants';
import * as ICON from './IconConstants';
import { IS_SHOW_MENU_DEVELOP_FEATURE_51, IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 } from './index';

const TOP_NAVIGATOR_CONFIG = [
  {
    title: 'アカウント管理',
    path: Path.ACCOUNT_EDIT,
    id: FUNCTION.ACCOUNT_EDIT,
    icon: ICON.KEY,
  },
  {
    title: '問い合わせ',
    id: FUNCTION.CONTACT,
    icon: ICON.CONTACT,
  },
  {
    title: 'マニュアル',
    id: FUNCTION.FAQ,
    icon: ICON.FAQ,
  },
  {
    title: 'ログアウト',
    id: FUNCTION.LOGOUT,
    icon: ICON.LOGOUT,
  },
];

export default TOP_NAVIGATOR_CONFIG;
